import { RootState } from '@/store'

export const getConnectorActivityMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.connectorActivity
}

export const getUserActivityMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.userActivity
}

export const getEngagementOverTimeMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.engagementOverTime
}

export const getDeviceMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.deviceMetrics
}

export const getTotalActiveUsers = (state: RootState) => {
  return state.spaceAnalyticsPage.totalActiveUsers
}

export const getPreviousTotalActiveUsers = (state: RootState) => {
  return state.spaceAnalyticsPage.previousTotalActiveUsers
}

export const getTotalActivity = (state: RootState) => {
  return state.spaceAnalyticsPage.totalActivity
}

export const getPreviousTotalActivity = (state: RootState) => {
  return state.spaceAnalyticsPage.previousTotalActivity
}

export const getTotalEngagedNow = (state: RootState) => {
  return state.spaceAnalyticsPage.totalEngagedNow
}

export const getTotalSpaceMembers = (state: RootState) => {
  return state.spaceAnalyticsPage.totalSpaceMembers
}

export const getPreviousTotalSpaceMembers = (state: RootState) => {
  return state.spaceAnalyticsPage.previousTotalSpaceMembers
}

export const getChatMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.chatMetrics
}

export const getPreviousChatMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.previousChatMetrics
}

export const getPublisherMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.publisherMetrics
}

export const getPreviousPublisherMetrics = (state: RootState) => {
  return state.spaceAnalyticsPage.previousPublisherMetrics
}

export const getTotalEngagements = (state: RootState) => {
  return state.spaceAnalyticsPage.totalEngagements
}

export const getPreviousTotalEngagements = (state: RootState) => {
  return state.spaceAnalyticsPage.previousTotalEngagements
}

export const getTotalEngagedUsers = (state: RootState) => {
  return state.spaceAnalyticsPage.totalEngagedUsers
}

export const getPreviousTotalEngagedUsers = (state: RootState) => {
  return state.spaceAnalyticsPage.previousTotalEngagedUsers
}
